export const fmtUsd = (n) => `$${Number(n || 0).toFixed(2)}`;
export const fmtNum = (n, d = 2) => Number(n || 0).toFixed(d);
